import { Link } from 'react-router';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function Unauthorized() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-red-50 to-orange-50 p-4">
            <Card className="w-full max-w-md p-8 text-center">
                <div className="flex justify-center mb-6">
                    <Shield className="h-16 w-16 text-red-500" />
                </div>

                <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>

                <p className="text-gray-600 mb-8">
                    You don't have permission to access this page. Please contact your administrator
                    if you believe this is an error.
                </p>

                <div className="space-y-3">
                    <Button asChild className="w-full">
                        <Link to="/dashboard">
                            <ArrowLeft className="mr-2 h-4 w-4" />
                            Go to Dashboard
                        </Link>
                    </Button>

                    <Button variant="outline" asChild className="w-full">
                        <Link to="/">Go Home</Link>
                    </Button>
                </div>
            </Card>
        </div>
    );
}
